export const createCampaign = /* GraphQL */ `
  mutation CreateCampaign(
    $input: CreateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    createCampaign(input: $input, condition: $condition) {
      id
      agentId
      atsListId
      channel
      closingMessage
      closingMethod
      contactNumber
      conversationCompletedMessage
      customRequest
      followUpMessage
      jobDescription
      meetingUrl
      organizationId
      outreachDescription
      additionalContext
      jobDescriptionText
      jobDescriptionParsed {
        jobTitle
        employerName
        location
        summaryOfRole
        contractType
      }
      questions {
        content
        isMandatory
        questionType
        documentTypes
        hasPreferredAnswer
        preferredAnswerRequirements
        preferredAnswerText
        order
        expectedAnswer
      }
      rejectionMessage
      status
      templateId
      timeToAutoCloseConversationsInHours
      title
      type
      userId
      webChatTemplateId
      csvS3Key
      totalProspectsCount
      totalConversationsCount
      initialMessagesSentCount
      createdAt
      updatedAt
      owner
    }
  }
`;

export const startSendingMessages = /* GraphQL */ `
  mutation StartSendingMessages($input: StartCampaignInput) {
    startSendingMessages(input: $input) {
      message
    }
  }
`;

export const startCampaign = /* GraphQL */ `
  mutation StartCampaign($input: StartCampaignInput) {
    startCampaign(input: $input) {
      message
    }
  }
`;

export const sendSimulationMessage = /* GraphQL */ `
  mutation SendSimulationMessage($input: SendSimulationMessageInput!) {
    sendSimulationMessage(input: $input) {
      message {
        id
        body
        userId
        sender
        simulationId
        createdAt
        updatedAt
      }
      simulationId
    }
  }
`;

export const updateCampaign = /* GraphQL */ `
  mutation UpdateCampaign(
    $input: UpdateCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    updateCampaign(input: $input, condition: $condition) {
      id
      title
      agentId
      userId
      organizationId
      status
      jobDescription
      jobDescriptionParsed {
        jobTitle
        employerName
        location
        summaryOfRole
        contractType
      }
      additionalContext
      jobDescriptionText
      meetingUrl
      contactNumber
      customRequest
      csvS3Key
      closingMethod
      closingMessage
      templateId
      candidateBatchId
      totalProspectsCount
      totalConversationsCount
      totalConversationsWithRepliesCount
      initialMessagesSentCount
      totalMessagesCount
      totalMessagesWithMeetingUrlCount
      totalMessagesWithCallRequest
      totalMessagesWithCustomRequest
      messagesProcessedCount
      createdAt
      updatedAt
      owner
      timeToAutoCloseConversationsInHours
      launchScheduleDateTime
      externalId
    }
  }
`;
export const initializeCampaign = /* GraphQL */ `
  mutation InitializeCampaign($input: InitializeCampaignInput!) {
    initializeCampaign(input: $input) {
      id
      agentId
      userId
      organizationId
      status
      jobDescription
      jobDescriptionParsed {
        jobTitle
        employerName
        location
        summaryOfRole
        contractType
      }
      additionalContext
      jobDescriptionText
      questions {
        content
        supportingInformation
        isMandatory
      }
      meetingUrl
      contactNumber
      customRequest
      csvS3Key
      closingMethod
      closingMessage
      templateId
      candidateBatchId
      totalProspectsCount
      totalConversationsCount
      totalConversationsWithRepliesCount
      initialMessagesSentCount
      totalMessagesCount
      totalMessagesWithMeetingUrlCount
      totalMessagesWithCallRequest
      totalMessagesWithCustomRequest
      timeToAutoCloseConversationsInHours
      launchScheduleDateTime
      messagesProcessedCount
      createdAt
      owner
      updatedAt
    }
  }
`;
export const createCampaignCsvKeys = /* GraphQL */ `
  mutation CreateCampaignCsvKeys(
    $input: CreateCampaignCsvKeysInput!
    $condition: ModelCampaignCsvKeysConditionInput
  ) {
    createCampaignCsvKeys(input: $input, condition: $condition) {
      id
      csvS3Key
      campaignId
      isProcessed
      createdAt
      updatedAt
    }
  }
`;
export const deleteCampaign = /* GraphQL */ `
  mutation DeleteCampaign(
    $input: DeleteCampaignInput!
    $condition: ModelCampaignConditionInput
  ) {
    deleteCampaign(input: $input, condition: $condition) {
      id
    }
  }
`;
